// eslint-disable-next-line import/extensions
import lCamelCase from 'lodash/camelCase'

const modulesFiles = import.meta.glob('./**/!(*.unit|index).js', { eager: true })

const moduleCache = {}
let root = buildModuleTree(modulesFiles)

function buildModuleTree(modulesMap) {
  const root = { modules: {} }

  Object.entries(modulesMap).forEach(([fileName, moduleDefinition]) => {
    const modulePath = fileName
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '')
      .split('/')
      .map(lCamelCase)

    const { modules } = getNamespace(root, modulePath)

    modules[modulePath.pop()] = {
      namespaced: true,
      ...moduleDefinition
    }

    moduleCache[fileName] = moduleDefinition
  })

  return root
}

function getNamespace(subtree, path) {
  if (path.length === 1) return subtree

  const namespace = path.shift()
  subtree.modules[namespace] = {
    modules: {},
    ...subtree.modules[namespace]
  }
  return getNamespace(subtree.modules[namespace], path)
}

export default root.modules

// HMR support
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    const newModulesFiles = import.meta.glob('./**/!(*.unit|index).js', { eager: true })
    const newRoot = buildModuleTree(newModulesFiles)

    // Update the root object (you can export a function to do this instead)
    root = newRoot

    // Import the store instance dynamically and hot-update it
    import('../index.js').then(({ default: store }) => {
      store.hotUpdate({
        modules: root.modules
      })
    })
  })
}
